module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"academy":"Academy","poweredBy":"Powered By"}}')
  delete Component.options._Ctor
}
